import React from "react";
import { Trash2, Download } from "lucide-react";
import { formatDate, downloadCsv } from "./adminUtils";

export default function NewsletterPanel({ items, onDelete }) {
  function exportCsv() {
    downloadCsv("newsletter-subscribers.csv", items, ["email", "created_at"]);
  }

  return (
    <>
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-display text-2xl text-[#7d8e54]">Newsletter Subscribers</h2>
        <button
          onClick={exportCsv}
          disabled={items.length === 0}
          className="flex items-center gap-2 text-sm border border-[#d6dcb6] px-3 py-1.5 hover:bg-[#f6f8ec] disabled:opacity-40"
        >
          <Download className="w-4 h-4" /> Export CSV
        </button>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-[#7d8e54] italic">No subscribers yet.</p>
      ) : (
        <div className="overflow-x-auto border border-[#d6dcb6]">
          <table className="w-full text-sm">
            <thead className="bg-[#f6f8ec] text-[#5b6a37]">
              <tr>
                <th className="text-left p-3">Email</th>
                <th className="text-left p-3">Subscribed</th>
                <th className="text-right p-3 w-24">Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map((s) => (
                <tr key={s.id} className="border-t border-[#eef0e0]">
                  <td className="p-3">{s.email}</td>
                  <td className="p-3 text-[#7d8e54]">{formatDate(s.created_at)}</td>
                  <td className="p-3 text-right">
                    <button
                      onClick={() => onDelete(s.id)}
                      className="text-red-700 hover:text-red-900 p-1"
                      title="Remove"
                      aria-label="Remove subscriber"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
